var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiCoatOfArms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 185,
    viewBox: "0 0 250 185",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-commonwealth-crest"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 185
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "commonwealth-crest",
    clipPath: "url(#clip-commonwealth-crest)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M8.986,10.834A1.211,1.211,0,1,0,7.794,9.642,1.192,1.192,0,0,0,8.986,10.834Z",
    transform: "translate(82.118 90.995)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M51.708,5.3H8.668V40.03c0,3.371,1.415,6.295,3.39,7.189L28.6,57.109A2.049,2.049,0,0,0,30.1,57.8a1.862,1.862,0,0,0,1.341-.54L48.207,47.219c1.862-.894,3.371-3.725,3.371-7.189V5.3ZM22.971,15.354H19.246v-8.9h3.725v8.9ZM20.2,18.445l.54-.54L20.4,17.29h.689l.428-.726.41.726h.689l-.317.615.521.54-.67.13v.764l-.633-.484-.652.484v-.782ZM9.823,29.62V21.071H14.33v8.455Zm.745-12.236h.689l.41-.726.41.726h.708L12.467,18l.521.54-.67.13v.764l-.652-.484-.633.484v-.875l-.67-.13.521-.54-.317-.615Zm5.1,8.586.8.037.41-.726.41.726H18l-.335.615.54.559-.67.112v.577l-.652-.484-.633.484v-.764l-.67-.112.521-.559-.317-.615Zm3-6.779c0-.223-.335-.3-.466-.3s-.559.67-.894.689-.428,0-.428-.261.5-.41.708-.6c-2.794,0-2.849,1.266-3.278,1.266-.726,0,.615-1.341,1.006-1.732-.577,0-.894-.782-1.527-1.136.3-.41.466-.242.819,0,0-.3.224-.633.875-.633,1.248,0,.894,1.211,1.1,1.211s0-1.211.819-1.211c1.248,0,2.794,3.185,1.378,3.185-.6,0-.112-.466-.112-.54Zm-3.2-9.312.521-.54-.317-.615h.689L16.769,8l.41.708h.708l-.335.615.54.54-.67.13v.764l-.652-.484-.633.484V9.99l-.67-.13ZM14.33,6.544v8.9H9.9v-9ZM22.9,52.453l-10.15-6.239a7.45,7.45,0,0,1-2.775-5.736V30.7H23.008v21.66ZM19.172,29.62V21.071H22.9v8.455ZM36.157,53.16l-4.749,2.831h0a1.862,1.862,0,0,1-1.248.447,1.993,1.993,0,0,1-1.266-.466l-4.73-2.812V30.811H36.25V53.16Zm0-23.541H24.144V6.451H36.231V29.526ZM50.423,40.57a7.45,7.45,0,0,1-2.794,5.736l-10.3,6.146V30.7H50.367v9.778Zm0-10.951H37.386V6.451H50.423V29.526Z",
    transform: "translate(94.728 46.025)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M20.645,13.99c0-.13-1.639.521-1.192.484,0-.466.913-1.415,1.3-1.769,0-.54-.764,0-1.509.335,2.458-3.5.875-2.067-.484-1.862,2.179-2.365,1.6-2.328,0-1.583C20.03,8.589,20.291,7.378,20.1,7.043c-1.192,1.583-2.291,1.322-2.291,2.794a5.811,5.811,0,0,1-.838,3.092c-.633.689-.149-2.589-1.862-2.589-.54,0-1.862,0-2.2.615.354,0,.857.875.857,1.211s.317,1.3-.261,1.3-1.229-1.192-1.229-1.862V10.339c0-1.4-2.272-3.334-3.185-3.334,0,.968,1.266,1.192,1.266,2.421-.54,0-1.3-1.006-1.3-.372s.8.726.8,1.266-.913-.186-.913.391.5.41.615.913c-.372-.093-.708,0-.764.149s0,.372.391.54c-.13.112-.242.41-.242,1.211,0,2.756,1.713,4.023,2.98,4.023.894,0,.764-.633.857-.931,0,.466.484-.223.484.577s-.875.484-.875,1.211,1.378,0,1.378,1.062a14.363,14.363,0,0,1-.149,1.862c0,.335,1.434-.484,1.341-.633.354.13.335,1.155.987,1.117s.5-1.043.819-1.136c-.186,0,1.3.987,1.3.521,0-1.285-.521-.745-.521-1.62s1.862-.652,1.49-1.062-.391-.149-.577-.745c0,.112-1.4-2.03.3-.931s1.974-2.7,1.862-2.905Z",
    transform: "translate(96.366 70.687)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M9.071,11.137A1.266,1.266,0,1,0,7.655,9.889,1.341,1.341,0,0,0,9.071,11.137Z",
    transform: "translate(80.115 93.877)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M9.355,11.161A1.266,1.266,0,1,0,7.94,9.913a1.341,1.341,0,0,0,1.415,1.248Z",
    transform: "translate(84.226 94.225)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M7.128,8.8a13.409,13.409,0,0,0,0,5.96c-.372.391-.3-.372-.67-.3-2.924-2.1-1.583-6.276-2.328-9.312A.577.577,0,0,1,4.874,5,5.382,5.382,0,0,1,7.128,8.726Z",
    transform: "translate(29.24 40.658)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M6.583,6.265a2.2,2.2,0,0,1-.968,1.62c-.447,0-1.117,0-1.4-.372a1.36,1.36,0,0,1-.3-1.471,1.732,1.732,0,0,1,1.4-.652c.521.223,1.043.372,1.266.968Z",
    transform: "translate(24.776 47.365)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M7.065,6.5c.223.745-.54,1.211-.987,1.583a1.509,1.509,0,0,1-1.49-.838c-.54-.521.149-.987.3-1.434A1.4,1.4,0,0,1,7.065,6.5Z",
    transform: "translate(32.917 49.38)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M6.488,6.612a1.509,1.509,0,0,1-.819,1.415A1.341,1.341,0,0,1,4.2,7.357a1.266,1.266,0,0,1,.67-1.713C5.669,5.346,6.19,6.091,6.488,6.612Z",
    transform: "translate(28.483 50.054)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M6.669,6.708c.2.894-.447,1.341-.968,1.862-.894.224-1.471-.447-1.862-1.043a1.862,1.862,0,0,1,.95-1.862,1.862,1.862,0,0,1,1.862.968Z",
    transform: "translate(24.838 51.15)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M6.938,7.247A1.6,1.6,0,0,1,5.821,8.662c-.577.447-1.024-.3-1.546-.521a1.751,1.751,0,0,1,0-1.713c.223-.447.745-.447,1.192-.6C6.119,6.2,6.789,6.5,6.938,7.247Z",
    transform: "translate(28.108 53.74)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M6.971,6.9c.3.764-.521,1.136-.819,1.509-.913.3-1.36-.372-1.732-.913s.3-1.211.819-1.658C6.152,5.619,6.6,6.215,6.971,6.9Z",
    transform: "translate(31.874 53.208)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M9.224,8.636A29.222,29.222,0,0,0,12.3,12.194a.615.615,0,0,1-.521.764C8.05,12.715,5.629,8.934,3.823,6.29c.223-.819,1.211-.149,1.732-.223,1.266.987,2.7,1.285,3.725,2.57Z",
    transform: "translate(24.816 54.418)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M9.539,7.261a40.584,40.584,0,0,1,4,3.483c-.968.67-2.142,0-3.259,0-2.514-.894-4.209-3.036-6.8-3.725,0-.819,1.043-.521,1.564-.745a13.465,13.465,0,0,1,4.488.968Z",
    transform: "translate(19.957 60.132)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M99.545,29.935c-4.209-1.658-6.984,2.719-11.268,2.2-.521.3-.372.819-.67,1.211s-.6,0-.819,0c-.224-1.862-.819-3.483-1.043-5.215-.466-.764-.242-1.862-.615-2.57-2.4-6.574,5.867-1.6,7.45-5.438,1.434-3.334-2.775-3.725-4.041-6.053V13.08C87.328,11.869,86.061,11.5,85.3,9.914a10.709,10.709,0,0,0,.261-5.9.809.809,0,0,0-1.043-.838c-1.434,1.974-2.477,3.557-3.725,5.457a42.367,42.367,0,0,0-4.544-3.334c-1.136-.149-2.179-1.285-3.445-.819a1.006,1.006,0,0,0,.223,1.117,10.82,10.82,0,0,0,3.725,7.45l.223,1.136c-1.341,3.092-.968,6.649-1.341,9.982a55.425,55.425,0,0,1-16.3,22.889c-4.265,4.842-9.312,9.535-10.057,16.184-.223,1.062.168,2.328-.67,3.092A26.074,26.074,0,0,1,41.625,62.6c-3.445-2.421-8.4-2.123-10.653-6.5-.894-1.732.223-3.464,1.062-4.749,2.551-2.421,2.16-6.742.819-9.685-.3,0-.372.3-.6.373-.223,4.47-3.725,7.561-2.4,12.478.3,1.434,1.043,2.347,1.415,3.725a11.568,11.568,0,0,1-1.713-.372,18.4,18.4,0,0,0-5.028-.689c-3.464,1.583-8.176-.372-10.951,2.794-.466,0-1.062.149-.913.838,1.658,0,3.222.447,4.879.372,2.626.447,4.358-1.732,6.146-2.719h.41c.745-.764,2.011-.3,3-.447,4.731.521,8.4,2.794,12.31,5.14v.3c-1.509.67-3.241,1.136-4.731,1.956a10.206,10.206,0,0,0-4.172,4.973c-1.192,1.862.372,3.557,1.136,5.14,0,.764.149,1.658.819,1.974,2.4-2.57.149-5.755.521-8.7a6.127,6.127,0,0,1,4.879-3.93c4.284-1.862,7.45,1.658,10.8,3.725a51.813,51.813,0,0,1-.354,10.169,9.313,9.313,0,0,1-3.52.521c-5.941.447-10.6,3.725-15.924,5.587-2.384.838-5.252.764-7.636,1.658A18.345,18.345,0,0,0,27,86.309c7.45-1.062,13.037-6.723,20.933-5.736l.149.223a17.655,17.655,0,0,1-3.5,4.842c-.242-.838-.317-1.509-1.062-1.974a1.415,1.415,0,0,0-1.732.615,1.043,1.043,0,0,0,0,1.136,2.533,2.533,0,0,0,1.658,1.043c-.149.689-.968.987-1.415,1.6-2.1,3.539-6.388,2.1-8.865,4.6-.372.54-1.732.838-1.117,1.676a11.323,11.323,0,0,0,7.692-1.974c2.775-3.092,5.7-6.053,8.567-8.939a8.958,8.958,0,0,1-1.658,6.872,8.753,8.753,0,0,0-2.011-1.117,1.862,1.862,0,0,0-1.36,1.509A4.432,4.432,0,0,0,44.4,92.195c-2.551,1.862-5.773,1.862-8.7,2.794A145.028,145.028,0,0,1,19.35,96.2c-2.626-.149-5.587.764-8.1,0-2.868.521-5.941-.372-8.269,1.211-.3.372,0,.764,0,1.136,3.464,2.272,8.195.447,12.087,1.136H44.586a13.149,13.149,0,0,0,6.071-1.136c3.837-2.2,5.922-6.127,7.878-9.982a15.551,15.551,0,0,0,1.583-4.526,6.518,6.518,0,0,1,5.587-4.619,34.25,34.25,0,0,1-1.211,11.454c-.447,2.421-2.03,4.768-1.043,7.338.223,1.192,1.509,1.192,2.477,1.36,9.07-.168,18.158-.54,27.768.149a22.647,22.647,0,0,0,5.1.745c.149-.224.67-.3.447-.745A2.868,2.868,0,0,0,97.385,97.6c-.149-.447-.819-.3-1.043-.6-4.805-2.719-10.578-1.285-16.222-1.211-2.924.3-5.848.819-8.325-.838-1.117-1.36-.3-5.587-.3-5.587a109.175,109.175,0,0,1,4.749-14.694,12.887,12.887,0,0,0,.447-3.464,14.732,14.732,0,0,0,.447-5.14,35.386,35.386,0,0,1,2.328-7.04c.447-1.117.819-2.328,1.285-3.464a11.342,11.342,0,0,1,1.49-3.93c2.458,1.546,4.842,1.509,6.016,4.284l1.024,6.295c0,.372.3,1.136.819.689,1.862-1.3,1.36-4.172,1.36-6.127.447-2.347-1.211-3.483-1.862-5.587a9.145,9.145,0,0,1-1.4-2.179c-.3-1.658-3.93-2.794-3.11-4.842a6.165,6.165,0,0,1,2.552-4.3.726.726,0,0,1,.372.521l.913-.615V33.436c2.421,0,6.053.317,8.53.317a9.051,9.051,0,0,0,1.862.819l.6-.819,6.09-1.192c-2.589.279-4.153-2.682-6.612-2.682Z",
    transform: "translate(10.742 14.682)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M9.543,5.14l.559-.112Z",
    transform: "translate(107.355 42.158)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M7.785,7.233A1.7,1.7,0,0,1,6.667,8.984c-.615-.242-1.062-.317-1.434-.913S5.68,6.637,6.276,6.339c.615.149,1.36.223,1.509.894Z",
    transform: "translate(43.818 61.073)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M7.1,6.659a1.7,1.7,0,0,1,.3,1.751c-.521.447-1.341.819-1.862.223s-.913-.987-.54-1.583A1.513,1.513,0,0,1,7.1,6.659Z",
    transform: "translate(39.553 61.647)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M6.146,7.792a1.453,1.453,0,0,1-1.993.968,3.036,3.036,0,0,1-.577-.968,1.322,1.322,0,0,1,.8-1.266A1.862,1.862,0,0,1,6.146,7.792Z",
    transform: "translate(21.245 63.755)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M8.148,7.788c0,.6-.764,1.117-1.285,1.434S5.6,8.682,5.224,8.161a1.509,1.509,0,0,1,.894-1.509,1.658,1.658,0,0,1,2.03,1.136Z",
    transform: "translate(44.963 64.727)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M7.445,7.158a1.173,1.173,0,0,1,.223,1.211c-.447.372-1.117,1.062-1.862.615-.447-.391-.968-.689-.819-1.453a3.2,3.2,0,0,1,1.136-.894c.6-.149.894.223,1.341.521Z",
    transform: "translate(41.234 64.873)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M6.944,7.625A1.49,1.49,0,0,1,6.05,9.488,1.178,1.178,0,0,1,4.616,9.1a1.3,1.3,0,0,1-.372-1.509c.149-.67.819-.521,1.285-.838a1.862,1.862,0,0,1,1.415.913Z",
    transform: "translate(29.424 66.995)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M7.145,7.821c.223.6-.466.819-.615,1.285a1.248,1.248,0,0,1-1.341.149c-.521-.466-1.136-1.136-.6-1.862.6-1.117,2.16-.521,2.551.391Z",
    transform: "translate(32.911 67.488)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M6.351,8.1c.3.6-.372.745-.6,1.043a1.471,1.471,0,0,1-1.471-.149c-.521-.3-.3-1.043-.223-1.415C4.712,6.31,6.053,7.2,6.351,8.1Z",
    transform: "translate(26.628 69.855)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M6.674,7.951c.168.615-.3.838-.447,1.285s-.894.3-1.266.149A1.248,1.248,0,1,1,6.674,7.951Z",
    transform: "translate(30.439 70.524)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M7.454,7.963c.3.67-.149,1.266-.745,1.658S5.722,9.472,5.275,9.4C4.9,8.857,4.232,8.261,4.9,7.647,5.573,6.511,6.932,7.125,7.454,7.963Z",
    transform: "translate(36.271 70.977)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M20.56,8.835c-.13,1.509-2.626-.2-2.272,1.862a11.4,11.4,0,0,0,1.49,4.246c.708,1.006.354,2.589.3,3.725a6.8,6.8,0,0,1-2.868,2.421c-2.123-.2-5.271,1.08-6.258-1.564A10.839,10.839,0,0,1,9.72,15.931c.224-.149.5-.149.726-.354,0-.5-.577-.8-.5-1.3,2.421-.428-1.006-2.589,1.062-2.719,1.713,1.862,4.507,1.211,6,3.147a5.588,5.588,0,0,0,1.062.931c-.279-1.862-1.136-3.576-1.415-5.587a2.477,2.477,0,0,1,.857-2.514c1.285-1.006,2.347.428,3.054,1.211Z",
    transform: "translate(109.916 73.29)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M7.317,7.978c.223.745-.372,1.211-.838,1.583S5.436,9.1,5.138,8.723c-.223-.745.3-1.136.745-1.509a1.639,1.639,0,0,1,1.434.764Z",
    transform: "translate(43.019 73.682)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M10.659,7.715a10.392,10.392,0,0,1-.913,8.474c0,.6.149,1.583-.67,1.509-2.03-2.794-.521-6.723.3-9.684.149-.745,1.062-1.043,1.285-.3Z",
    transform: "translate(85.977 74.69)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M14.247,8.129c-.447.894-1.732,1.136-2.551,1.732a9,9,0,0,1-6.686,1.285,8.2,8.2,0,0,1,8.567-3.557C13.725,7.906,14.1,7.757,14.247,8.129Z",
    transform: "translate(41.937 76.548)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M4.292,7.639c2.719,1.862,3.464,4.619,5.084,7.3.223.3.968.372.67.968-.6.447-1.192-.447-1.993-.3A8.176,8.176,0,0,1,3.547,7.937c0-.3.447-.3.745-.3Z",
    transform: "translate(20.716 79.831)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M5.539,9.278c-.372.3,0,.968-.745,1.043a1.192,1.192,0,0,1-1.546-.67,1.322,1.322,0,0,1,.968-1.639C4.794,8.309,5.39,8.533,5.539,9.278Z",
    transform: "translate(15.837 85.195)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M13.689,10.062c.223.689-.521.689-.894.838A8.176,8.176,0,0,1,4.153,8.7c0-.3,0-.6.3-.67,3.073.745,6.686.149,9.312,2.03Z",
    transform: "translate(29.589 85.492)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M6.129,8.655a1.862,1.862,0,0,1,.149,1.117,1.639,1.639,0,0,1-1.862.67,2.421,2.421,0,0,1-.968-.968A1.862,1.862,0,0,1,4.714,8.059a2.2,2.2,0,0,1,1.4.6Z",
    transform: "translate(19.4 85.892)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M10.588,8.749c.149.67-.447,1.136-.894,1.434A1.453,1.453,0,0,1,8.13,9.569a1.08,1.08,0,0,1,.521-1.434c.67-.149,1.713,0,1.862.615Z",
    transform: "translate(85.507 86.208)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M5.763,9.307c0,.521-.354.819-.5,1.248s-.745.447-1.192.3a2.1,2.1,0,0,1-1.1-1.192A1.862,1.862,0,0,1,4.292,8.19,1.862,1.862,0,0,1,5.763,9.307Z",
    transform: "translate(12.503 87.773)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M6.064,9.7c-.149.521-.372,1.024-1.024,1.1s-.894-.521-1.266-.8c0-.67,0-1.341.6-1.713A1.341,1.341,0,0,1,6.064,9.7Z",
    transform: "translate(24.102 88.493)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M6,9.371a1.564,1.564,0,0,1-.726,1.639A1.732,1.732,0,0,1,3.286,9.967,2.049,2.049,0,0,1,4.608,8.272c.67,0,1.043.745,1.4,1.1Z",
    transform: "translate(17.066 88.958)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M5.906,9.347c.223.5-.223.726-.372,1.1-.372,0-.6.447-1.043.3A1.359,1.359,0,0,1,3.541,9.7c-.074-.521.447-1.1.95-1.415A1.415,1.415,0,0,1,5.906,9.347Z",
    transform: "translate(20.647 89.148)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M7.771,9.247c.447.447,0,.987-.149,1.434a1.453,1.453,0,0,1-1.862.372c-.745-.3-.67-1.285-.521-1.862.447-.149.447-.689,1.043-.689a2.5,2.5,0,0,1,1.509.764Z",
    transform: "translate(43.832 92.284)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M13.2,8.988l-.3.521a11.919,11.919,0,0,1-9.517,1.713l-.3-.447a13.372,13.372,0,0,1,9.908-2.011Z",
    transform: "translate(14.192 92.692)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M7.258,9.613c-.3.6-.149,1.211-.894,1.509A1.62,1.62,0,0,1,4.5,10.134c-.223-.838.372-1.062.745-1.434.913-.447,1.583.224,2.03.913Z",
    transform: "translate(33.915 93.055)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M6.852,9.833c.223.521-.223.838-.372,1.211a1.4,1.4,0,0,1-1.509.223A1.732,1.732,0,0,1,4.152,9.4a3.967,3.967,0,0,1,1.192-.838c.689.149,1.36.447,1.509,1.211Z",
    transform: "translate(28.994 93.207)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M11.078,8.83c.223.6-.3.819-.372,1.266a10.82,10.82,0,0,1-1.62,3.2c-1.4,1.713-3.39,1.713-5.382,2.235l-.3-.6a19.462,19.462,0,0,1,7.45-6.258l.223.149Z",
    transform: "translate(18.79 94.862)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M6.985,9.456c0,.149,0,.3.223.372,0,.838-.67,1.062-1.117,1.434a2.049,2.049,0,0,1-1.658-.745,1.285,1.285,0,0,1,.745-1.751c.689,0,1.583,0,1.862.689Z",
    transform: "translate(31.934 96.099)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M6.529,9.863c.3.67-.3,1.192-.652,1.49a1.732,1.732,0,0,1-1.713-.6c-.5-.819.447-1.49,1.043-1.862s.95.521,1.322.894Z",
    transform: "translate(27.697 96.66)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M9.02,11a1.471,1.471,0,0,1-1.136,1.285A1.49,1.49,0,0,1,6.6,11.541c-.3-.913.466-1.285.987-1.658A1.862,1.862,0,0,1,9.02,11Z",
    transform: "translate(63.907 112.209)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M7.847,11.218a1.4,1.4,0,0,1-.968,1.434A1.378,1.378,0,0,1,5.3,11.963a1.36,1.36,0,0,1,.615-1.732c.819-.521,1.639.372,1.862.987Z",
    transform: "translate(44.501 114.953)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M245.193,38.853a6,6,0,0,0-5.587-3.11,5.159,5.159,0,0,0-4.19,3.11,3.837,3.837,0,0,0,1.415,4.153,1.173,1.173,0,0,0,1.509-.372c.372-.987-.67-.987-.819-1.751a2.477,2.477,0,0,1,.819-2.645c.745-.745,2.03-.372,2.924-.372a5.233,5.233,0,0,1,2.254,2.2,6.146,6.146,0,0,1,0,4,6.76,6.76,0,0,1-4.656,3.725c-6.22.894-74.5.6-74.5.6-8.027.764-17.171-1.509-24.081,2.719-3.147,1.509-4.73,4.991-5.587,8.083a55.442,55.442,0,0,0-5.978,6.053l-.223-.223c.372-1.862,1.211-3.408,1.583-5.215,1.117-1.509,1.117-3.557,1.956-5.215,2.849-4.619,5.587-9.312,9.982-12.553,1.862-2.5,5.177-2.03,8.027-2.03a19.965,19.965,0,0,0,10.429,1.509.689.689,0,0,0,.224-.54c-1.062-.968-2.775-1.36-3.986-2.328-3-1.453-5.848.447-9,.223-.149-.168-.3-.223-.223-.466a44.7,44.7,0,0,1,9.312-4.991,64.344,64.344,0,0,1,8.176-3.241c1.136,0,2.179-.987,3.241-.3l3.967-1.062c.149,0,.3.3.615.223,3.371-1.136,7.654,0,11.472-.149l.521.447,3.613.913c1.341.149,1.862,1.732,3.371,1.862.745-1.043-.819-1.509-1.211-2.179a8.213,8.213,0,0,1,5.028.745l-.745.838c-.447.838.224,1.434.894,1.732s.913-.223,1.285-.372c.968-.689,0-1.36.223-1.862a70.77,70.77,0,0,1,15.961,4.433,13.038,13.038,0,0,0,4.358,1.434,19.684,19.684,0,0,0-5.7-3.017c-1.285-.764-3.092-.838-4.06-1.862.223-.372.745-.223.968-.521a11.174,11.174,0,0,0,6.537-4.228c.149-.466.968-.317.894-.913-.67-.764-1.862.223-2.7.149-3.147.6-4.488,4.3-7.654,4.991-3.725-.913-7.729-1.862-11.547-2.794a23.447,23.447,0,0,1-5.587-1.211l-4.209-.391h-7.654c0-.149-.3-.223-.223-.447,2.7-.67,5.028-2.272,7.729-2.943l20.114-9.219a49.785,49.785,0,0,0,5.7-6.2,1.434,1.434,0,0,0-.82-1.434,1.266,1.266,0,0,0-1.508.3c-.894.689,0,1.509,0,2.347a12.4,12.4,0,0,1-3.445,2.943c-.3,0-20.71,9.312-20.71,9.312a50.843,50.843,0,0,1-9.163,3.408l-4.358.67a2.849,2.849,0,0,1-1.862,1.751,18.417,18.417,0,0,1-3.464.987c-9.74,3.725-19.872,7.785-27.6,15.5a8.7,8.7,0,0,0,.745-3.185,6.221,6.221,0,0,0-.82-3.315c-.186-.428-.726-1.639-.559-2.086l-1.1.726a10.541,10.541,0,0,0-.6,6.407c.224,1.36,1.341,2.961.3,4.172-3.594,4.377-5.587,9.666-8.027,14.657-.913-.149-1.36-.987-1.732-1.862a25.068,25.068,0,0,0,5.308-11.081c.521-.372.149-1.36.671-1.862-.149-1.211.689-2.421.093-3.408.466-1.658-2.2-3.166-.5-4.228l-1.415.67c-3.222,4.246,1.676,10.578-1.993,14.676v.3a13.036,13.036,0,0,1-3,3.725c-1.862-.764-2.477-2.812-3.539-4.321-1.639-1.583-1.639-4.824-.67-7.021.67-2.2-.447-4.079-.67-6.053L119,40.51a8.753,8.753,0,0,0-1.062,8.846c.745,1.36.838,3.241,1.956,4.377a24.323,24.323,0,0,0,3.222,5.587c.3.764-.447.913-.819,1.285-.819-.521-.67-1.732-1.434-2.254a55.091,55.091,0,0,0-9.591-13.838c-.149-.689-.838-1.285-.466-2.049a5.587,5.587,0,0,0,.987-5.736c-.149-.372-.6-.838-.521-1.211l-1.136-.913c.149,2.645-1.564,4.991-.819,7.785v.149A143.406,143.406,0,0,0,84.338,27.455l-.708,1.862A51.777,51.777,0,0,1,91.657,33.4a50.285,50.285,0,0,1,7.45,4.023c10.206,5.587,16.966,15.03,21.529,25.459,0,.838.838,1.732.3,2.57a39.522,39.522,0,0,0-5.643-5.792,11.007,11.007,0,0,0-5.7-8.4c-1.117-1.658-3.52-1.862-5.4-2.347L76.869,48.76c-22.2-.3-42.463.689-64.532.317-3.073-.317-6.816-1.36-7.729-4.619a5.047,5.047,0,0,1,0-4.153,4.619,4.619,0,0,1,3.837-2.049A4,4,0,0,1,11,40.38c0,.987-.838,1.862-1.211,2.719,0,.3.372.913.913.67a3.5,3.5,0,0,0,1.862-2.4c0-.54.3-1.285-.223-1.676A5.01,5.01,0,0,0,8.817,36.6a6.258,6.258,0,0,0-5.1,1.732C1.852,39.84,1.982,42.577,2.5,44.682a10.132,10.132,0,0,0,8.12,6.053l73.006.3c7.133.372,15.16-.838,22.349.615a8.6,8.6,0,0,1,6.165,5.792c0,.149-.3,0-.521,0a32.517,32.517,0,0,0-21.325-4.3,25.869,25.869,0,0,0-8.4,1.732,4.228,4.228,0,0,1-3.725-1.211c-2.7-2.421-7.45-2.272-10.876-1.36v.521c3.725-.3,5.848,2.887,9.144,3.259.745.149,1.36-.689,2.03,0a66.878,66.878,0,0,1-10.429,4.675c-1.136-.223-1.732-1.285-2.626-1.862-1.434-1.583-4.06-.913-6-1.062-.689.149-1.285-.3-1.732,0a6.332,6.332,0,0,0,3.222,2.5c1.862.838,4.06,0,5.773,1.062a7.99,7.99,0,0,1-1.564,1.062c-3.539,1.36-6.463,4.526-10.355,4.3a13.447,13.447,0,0,1-11.174-3.725,7.45,7.45,0,0,0-7.58-4.377c-.223.149-.521.149-.447.521,1.658.987,2.924,2.943,4.582,4.079,1.062,1.285,3.073,0,4.06,1.434a13.036,13.036,0,0,0,4.88,2.123,19.947,19.947,0,0,0,3.892,1.062l-.521.3c-6.835,2.272-14.713,2.5-22.349,2.2-2.254,0-4.433-.764-6.667-.689A4.06,4.06,0,0,0,25.3,70.737a4.544,4.544,0,0,1-2.011.615,13.577,13.577,0,0,0-2.868.745,7.6,7.6,0,0,0-3.222.764,14.993,14.993,0,0,1-4.172,3.557c0,.317-.093.764.3.764,1.415-.6,3.222-.149,4.637-.764,2.477-.223,3.911-2.943,5.867-4.079,2.086-1.658,5.1-1.285,7.654-.894,1.49.372-.149.968.3,1.862.6.54,1.117,1.136,1.862.913a1.341,1.341,0,0,1,.521-.372,1.751,1.751,0,0,0,0-1.862c1.043-.67,2.477,0,3.594-.373,2.849,0,5.7-.689,8.493-.764.447,0,.968-.521,1.415,0-.224.615-.968.689-.67,1.509a1.767,1.767,0,0,0,1.49,1.136c.764-.3,1.434-.819,1.136-1.862-.149-.54-.745-.615-1.136-.838,1.583-.764,3.39-.987,4.954-1.732A13.915,13.915,0,0,0,56.588,68c.987,0,1.862-.987,2.719-.6a16.893,16.893,0,0,1-1.583,3.613c-1.192,4-2.1,9.312,0,13.149.223.093.3,0,.447-.149-1.583-4-.67-8.6.67-12.385C59.9,65.205,66.5,63.306,71.226,60.9l.224.3c-1.266,3.315-3.147,6.5-2.849,10.5.149.67-.3,1.36,0,1.862a7.711,7.711,0,0,0,2.775-3.483c.521-3.39-1.415-7.617,2.03-10.113,6.146-2.421,11.938-5.587,19.052-5.587.242.242.764-.149.838.317-1.509,1.658-3.725,3.241-4.358,5.289-2.4,3.315-2.328,9-1.266,13.037.67,2.347-1.36,3.725-2.328,5.438-.466.633-.6,1.751-1.043,2.477l1.49.168a8.064,8.064,0,0,0,2.552-4.991,2.049,2.049,0,0,0,1.415,1.509c.54-.819-.447-1.434-.521-2.254,1.211-.689,1.732.819,2.7,1.117a18.623,18.623,0,0,0,4.582,1.062l.521-.521c-1.639-2.57-4.954-3.017-7.8-3.185a15.16,15.16,0,0,1-1.341-8.6,13.3,13.3,0,0,1,1.49-4.693,11.4,11.4,0,0,1,2.272-3.036,10.411,10.411,0,0,1,4.73-2.57h.223a.335.335,0,0,0,0,.223c-2.03,1.583-2.254,3.725-3.445,5.755a6.313,6.313,0,0,0-.689,6.574c.466.968.223,2.477,1.285,3.166a16.762,16.762,0,0,0,1.62-4.619c-.224-2.477-1.713-4.824-.3-7.245a6.276,6.276,0,0,1,4.023-3.334c4.135-.372,7.729,1.751,11.323,3.334.764.521,2.03.987,2.179,2.049A6.146,6.146,0,0,1,103,65.82a5.2,5.2,0,0,1-1.192-4.6,3.092,3.092,0,0,1,3.3-1.211c.764.372,1.434,1.136,2.4.67a.95.95,0,0,0,.3-1.211c-.819-.447-1.117-1.583-2.254-1.732a4.842,4.842,0,0,0-4.116.838A5.308,5.308,0,0,0,99.7,63.865a6.481,6.481,0,0,0,4.656,4.842,8.753,8.753,0,0,0,9.312-3.185,10.224,10.224,0,0,0,1.639-3.241,19.388,19.388,0,0,1,7.729,9.964,16.2,16.2,0,0,1,0,3.725l2.626.223a2.533,2.533,0,0,1,.223-1.862,22.908,22.908,0,0,1,7.729-12.4c1.285-.745.987.987,1.285,1.527a10.094,10.094,0,0,0,6.518,5.736,8.25,8.25,0,0,0,8.12-2.645c.968-1.862,2.16-4.451.521-6.351a5.2,5.2,0,0,0-4.135-1.862,5.066,5.066,0,0,0-3.986,2.812c0,.6,0,1.285.447,1.583.3,0,.894,0,1.117-.372.149-1.136,1.136-1.676,2.03-2.272a2.365,2.365,0,0,1,2.4.447,4.023,4.023,0,0,1,1.043,2.961,4.507,4.507,0,0,1-2.551,3.613,7.617,7.617,0,0,1-7.208-.67,16.761,16.761,0,0,1-2.086-3.334c-.149-1.211-.615-2.272,0-3.464a25.1,25.1,0,0,1,10.727-3.725,7.6,7.6,0,0,1,3.967,2.5c3.464,3.539-.745,8.6,1.658,12.534.894-.149.894-1.36,1.266-2.1,1.136-2.719-.3-5.587-.968-8.325a15.235,15.235,0,0,0-2.849-4.581,1.862,1.862,0,0,1,.894-.149,17.8,17.8,0,0,1,4.582,3.874,20.17,20.17,0,0,1,2.924,12.385c-.6,2.272-3,3.334-4.88,4.153a7.189,7.189,0,0,0-2.011,2.421c.894.54,2.16,0,3.073-.372,1.415-.521,2.253-2.347,3.222-3.166.149,0,0,.3.149.447,0,.838-.372,1.862.373,2.2a27.492,27.492,0,0,0,.689-3.855,7.45,7.45,0,0,1,1.415,3.725c.67,1.36,1.862,3.166,3.594,3.39.466-.67,0-1.36-.224-1.956-.223-1.862-1.862-2.887-2.849-4.246-2.626-3.613-1.415-9.312-3.445-13.372a15.644,15.644,0,0,0-4.06-5.587l.3-.3a43.878,43.878,0,0,1,10.132,1.862c4.135,2.03,10.131,1.583,12.087,6.947a19.741,19.741,0,0,0,4.283,8.176l.224-.168a3.073,3.073,0,0,0,0-2.794c-.447-3.725-3.725-4.675-5.475-7.859l.223-.3a53.024,53.024,0,0,1,5.475,1.732A16.166,16.166,0,0,1,192.58,76.808a29.5,29.5,0,0,1-2.775,12.925c-.223.6-1.266,1.285-.6,1.862.819-.6.968-1.583,1.415-2.272A20.952,20.952,0,0,0,193.1,74.145c0-.987-1.192-1.751-.671-2.719a2.4,2.4,0,0,0,1.285.67c.447-.3,1.117-.3,1.415-.819s.372-.987,0-1.378a2.086,2.086,0,0,0-2.179-.521,3.614,3.614,0,0,0-.894,1.658,15.774,15.774,0,0,0-2.7-3.93l.149-.224c3.371,1.136,6.444,2.794,9.908,3.725a4.936,4.936,0,0,0,2.626.838,72.078,72.078,0,0,0,9.312,2.328c2.235-.224,4.116.838,6.369.317V73.94h0c-.819-1.062-2.626,0-3.594-.838a55.761,55.761,0,0,1-14.787-3.725c0-.224.372-.149.6-.149a1.862,1.862,0,0,0,1.192-1.862,1.993,1.993,0,0,0-1.713-.838,2.1,2.1,0,0,0-1.136,1.285,1.862,1.862,0,0,0,1.136,1.434c-.149.149-.447,0-.67,0-2.328-1.062-4.582-2.049-6.835-3.092-.819-.168-1.509-.838-2.328-.987-1.732-.838-3.445-1.658-5.177-2.347a117.574,117.574,0,0,0-15.234-5.587l-3.222-.913c-1.862-.521-3.725-.987-5.587-1.509-6.388-1.583-14.9-1.732-20.486,1.732-.913-.3-1.434,1.136-1.862.224,1.583-4.153,6.146-5.587,10.28-5.587,30.1-.3,58.312-.521,87.943-.987a9.48,9.48,0,0,0,8.623-4.3,7.58,7.58,0,0,0,.54-6.947ZM125.869,66.789a6.835,6.835,0,0,0-.82,2.645l-.3.149c.223-1.136-.894-1.862-.6-3.017-.615-.913-.615-2.049-1.136-3.017s.6-1.751,1.136-2.57c1.043.447,1.415,1.434,2.16,2.328C126.782,64.591,125.795,65.578,125.869,66.789Z",
    transform: "translate(0.919 66.385)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M33.367,3.863a1.862,1.862,0,1,1,0,3.725H11.111a1.862,1.862,0,1,1,0-3.725ZM17.629,7.1c2.179,0,.112-2.645-1.062-2.645h-2.16c-2.179,0-.13,2.645,1.043,2.645Zm9.107,0c2.179,0,.13-2.645-1.043-2.645H23.514c-2.179,0-.112,2.645,1.062,2.645ZM33.46,4.459H32.64c-2.179,0-.335,2.645.838,2.645,1.453,0,1.546-2.645,0-2.645Z",
    transform: "translate(103.106 25.333)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M12.235,5.515l4.246,1.639,4.19-1.639-1.658,6.258,3.315-.689-1.136,3.725,1.136,3.725-2.943-.782,1.285,6.742-4.19-1.639-4.246,1.62,1.732-6.742-3.39.95.913-3.725-.913-3.725,3.241.54L12.235,5.515ZM18.511,16.8c.95,0,1.043-1.3,1.043-2.44,0-2.589-2.049,0-3.092-2.44-.764,2.049-2.868.149-2.868,2.347,0,1.527,0,2.533,1.509,2.533Zm-4.172-2.328c0,.987,1.322.335,2.291.335s2.309.652,2.309-.335c0-1.378-1.322-.894-2.309-.894S14.339,13.1,14.339,14.473Z",
    transform: "translate(122.282 49.177)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M10.72,8.776V7.994l-.726-.149.559-.577-.335-.633.726.075.447-.782.428.782.745-.075-.354.633.559.577-.708.149v.782l-.67-.5-.67.5Z",
    transform: "translate(113.852 55.117)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M10.506,9.034V8.252l-.726-.13.559-.6L10,6.892l.726.074.447-.764.428.764.726-.074L12,7.525l.559.6-.708.13v.782l-.67-.484-.67.484Z",
    transform: "translate(110.769 59.105)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M10.851,9.018v-.8l-.708-.13.559-.6-.354-.633.726.074.447-.764.428.764.745-.074-.335.633.559.6-.726.13v.8l-.67-.521-.67.521Z",
    transform: "translate(116.012 58.6)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M10.615,8.056V7.609l-.41-.074.317-.335-.2-.354.41.037.261-.428.242.428.41-.037-.186.354.317.335-.41.074v.447l-.372-.279-.372.279Z",
    transform: "translate(116.917 62.728)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M11.026,11.357V10L9.816,9.755l.95-.987-.6-1.1,1.248.13.764-1.322.745,1.3,1.266-.112-.6,1.1.95.987L13.336,10v1.36L12.181,10.5l-1.155.857Z",
    transform: "translate(111.292 63.059)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M20.951,2.173l2.645,6.5L30.3,6.7l-3.408,6.127,5.7,4.041-6.872,1.155.41,7.021-5.177-4.712-5.177,4.712.428-7.021L9.311,16.867l5.718-4.041L11.621,6.7l6.686,1.974,2.645-6.5Z",
    transform: "translate(104.011 0.95)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M15.342,8.3c0-3.092-1.732-.2-2.682-2.831-.708,2.216-2.794.354-2.794,2.738a1.862,1.862,0,0,0,.689,1.732v.913a.41.41,0,0,0,.41.428h3.278a.428.428,0,0,0,.428-.428V9.862a2.011,2.011,0,0,0,.67-1.564Zm-2.682.577c-.894,0-2.1.633-2.1-.447,0-1.509,1.024-1.173,1.862-1.173s2.309-.335,2.309,1.173c0,1.08-1.211.447-2.123.447Z",
    transform: "translate(111.743 48.481)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M9.2,5.142a7.86,7.86,0,0,0-.67,1.322.67.67,0,0,0,1.341,0Z",
    transform: "translate(92.69 43.795)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M9.918,5.142a7.954,7.954,0,0,0-.652,1.322.67.67,0,0,0,1.341,0Z",
    transform: "translate(103.367 43.795)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M10.671,5.142A7.858,7.858,0,0,0,10,6.464a.67.67,0,1,0,1.341,0Z",
    transform: "translate(113.956 43.795)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M9.221,6.156a7.952,7.952,0,0,1,.652,1.322.67.67,0,0,1-1.341,0Z",
    transform: "translate(92.76 58.426)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M9.221,7.13a7.952,7.952,0,0,1,.652,1.322.67.67,0,1,1-1.341,0Z",
    transform: "translate(92.76 72.481)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M9.318,7.9a7.861,7.861,0,0,1,.67,1.322.67.67,0,0,1-1.341,0Z",
    transform: "translate(94.432 83.663)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M9.954,8.318a7.951,7.951,0,0,1,.652,1.322.67.67,0,1,1-1.341,0Z",
    transform: "translate(103.35 89.619)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M10.675,8.755a7.953,7.953,0,0,0-.652,1.322.67.67,0,0,0,1.341,0Z",
    transform: "translate(114.287 95.924)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M21.366,9.387c.149.2.5.279.95.13l.428-1.229s-.484-.559-.8-.484c-1.211.3-2.5.428-3.2,1.583a2.347,2.347,0,0,0,1.136,1.862c.428-.149.5.3.782.5a.5.5,0,0,1-.5.652c-.857-.857-2.347.279-2.98-.8.279-1.062.857-2.291,0-3.3,0-.2.428-.428.2-.652-.354-1.006-1.415-.2-2.067-.2a2.738,2.738,0,0,0-2.57,1.285,2.067,2.067,0,0,0,.577,1.08c.279,0,.428,0,.5.279l-.708.447a1.583,1.583,0,0,1,.279.782c-.5.223-1.006-.5-1.211-.857s0-1.583-.726-1.732a3.334,3.334,0,0,0-.615.2,2.16,2.16,0,0,0-.279,1.192,4.786,4.786,0,0,0,.279,1.285,12.106,12.106,0,0,1,2.533,2.645c-.633,1.285-.633,3.073-2.123,3.725-.428.279-.428.708-.428,1.136l.354.3c.931-.5,2.7-.652,2.57-2.235a5.848,5.848,0,0,1,1.341-1.862,1.509,1.509,0,0,1,1.639.782,2.775,2.775,0,0,1-1.862,2.16c-.149.149,0,.372,0,.577.3.5,1.08.279,1.509.223,1.211-.8,1.713-2.235,2.775-2.663.149.708-1.434.931-.428,1.658.633-.149,1.49,0,1.862-.8-.5-1.211,1.713-1.862.354-2.868,0-1.08,1.155-1.509,1.08-2.663-.428-1.136-1.862-1.136-2.142-2.216a1.509,1.509,0,0,1,1.49,0Z",
    transform: "translate(122.035 72.738)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M9.2,10.464a1.248,1.248,0,1,0,0-2.477,1.248,1.248,0,1,0,0,2.477Z",
    transform: "translate(82.15 84.716)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M60.662,5.095H8.366V45.062c0,4.079,1.732,7.636,4.116,8.735L32.6,66.572a2.44,2.44,0,0,0,1.862.819,2.384,2.384,0,0,0,1.639-.633L56.584,53.722c2.384-1.1,4.116-4.656,4.116-8.735V5.02ZM59.191,45.6a8.921,8.921,0,0,1-3.39,6.965L36.1,65.1h-.112a2.458,2.458,0,0,1-1.527.54,2.533,2.533,0,0,1-1.546-.559L13.246,52.567A9,9,0,0,1,9.837,45.6V6.491H59.191Z",
    transform: "translate(90.374 42.036)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M10.517,9.1l.652-.317a4.285,4.285,0,0,0-.652.317Z",
    transform: "translate(121.411 96.29)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M5.188,11.128c0,.372.279.67.2,1.043a1.6,1.6,0,0,1-1.024.875,1.527,1.527,0,0,1-1.695-.95A1.471,1.471,0,0,1,3.4,10.532a1.527,1.527,0,0,1,1.862.6Z",
    transform: "translate(7.844 119.959)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M5.348,11.422a1.583,1.583,0,0,1-.894,1.862,1.7,1.7,0,0,1-1.62-1.043A1.36,1.36,0,0,1,3.56,10.7a1.676,1.676,0,0,1,1.862.726Z",
    transform: "translate(9.975 123.074)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M8.075,11.46a1.509,1.509,0,0,1-.615.615",
    transform: "translate(77.311 134.956)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M13.848,10.408A1.266,1.266,0,1,0,12.433,9.16a1.341,1.341,0,0,0,1.415,1.248Z",
    transform: "translate(149.052 83.357)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M13.478,10.629a1.266,1.266,0,1,0-1.415-1.248,1.341,1.341,0,0,0,1.415,1.248Z",
    transform: "translate(143.705 86.545)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M16.459,6.517a15.848,15.848,0,0,1,1.49,5.438c-.3,1.434.223,3.334-.819,4.321-1.043-.391-1.117-1.676-1.862-2.347-1.341-2.645-.149-5.755.3-8.325.615-.223.615.54.838.913Z",
    transform: "translate(181.026 49.888)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M11.76,6.454v.112",
    transform: "translate(139.35 62.728)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M14.431,9.047a8.6,8.6,0,0,1,.149,7.04l-.615.6a17.358,17.358,0,0,1-1.713-5.364,18.327,18.327,0,0,0,.894-4c1.062-.223.968,1.136,1.285,1.732Z",
    transform: "translate(146.439 74.792)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M14.506,8.352c0,.745,0,1.509-.67,1.732A1.378,1.378,0,0,1,12.1,9.264c-.224-.521.223-.819.391-1.211a1.322,1.322,0,0,1,2.011.391Z",
    transform: "translate(143.421 81.391)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M52.555,72.974a37.255,37.255,0,0,1,.521-4.153,2.812,2.812,0,0,0,.3-1.6c1.862-2.421,5.475-1.658,8.325-1.434a15.291,15.291,0,0,0,3.725.838,2.738,2.738,0,0,1,1.862-.372c2.4-1.285.838-4.079.987-6.276L67.361,57.7a9.091,9.091,0,0,1-.6-1.509c-.447-.521-.745-1.509-1.192-2.049-1.285-3.315-3.725-5.215-5.867-7.859-3.725-4.991-9.815-7.785-15.83-9.74s-11.919.6-17.246,2.5a4.321,4.321,0,0,1-2.924-3.185,14.9,14.9,0,0,1,1.415-8.008c.224-1.862,1.509-3.315,2.03-5.066A54.013,54.013,0,0,0,30.225,9.745a6.816,6.816,0,0,0-4.06-5.96,4.079,4.079,0,0,0-4.116.819A10.9,10.9,0,0,1,17.17,9c-.149,1.285,1.415.447,1.862.894,1.639.317,3.52-.223,4.879.838a12.851,12.851,0,0,1-3.166,7.785,59.6,59.6,0,0,0-6.816,11.789l-.3-.3.354,18.475c2.4,3.986,5.382,8.511,9.852,10.02,2.384,1.956,5.4,4.3,8.623,2.57,1.732-.54,1.862,1.862,2.7,2.868.894,2.794-1.117,4.768-1.285,7.319l-1.862,4.172c-2.254,4.377-4.284,9.07-7.729,12.776-1.136,0-1.862,1.192-2.924,1.285-.615.819-1.862.223-2.552.521-2.328.987-5.587.372-7.208,2.57a1.024,1.024,0,0,0,.6.372c4.582,0,9.684.391,14.564.149a1.862,1.862,0,0,0,1.192-1.434c-.67-1.285.223-2.421.819-3.39.391-1.862,1.583-2.961,2.1-4.693,1.583-3.092,3.39-6.127,5.1-9.219l2.328-3.725a26.761,26.761,0,0,1,2.328-4.228A10.579,10.579,0,0,0,42,64.369a2.091,2.091,0,0,0-.764-1.583c.521-.521,1.36-.372,2.03-.521a8.437,8.437,0,0,1,4.209,4.973l.671,1.974.3.913L48.29,72.6l.3,2.347a54.288,54.288,0,0,1-.67,10.97c-1.285,4.377-6.314,3.93-9.908,4.917-.894.6-2.626.3-2.626,1.862,4.358.913,9.461.372,14.117.3.745-.3.894-.987,1.266-1.658.149-.987,1.117-1.862.819-2.868-.819-1.062,0-2.719-.3-4.153a2.4,2.4,0,0,0,0-1.453c.6-2.179.447-4.824.913-6.947l.3-2.868Z",
    transform: "translate(137.051 20.773)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M15.9,8.827a2.254,2.254,0,0,1,0,.987c-.447.615-1.062,1.136-1.862.764-.447-.466-.968-.913-.745-1.583a1.471,1.471,0,0,1,2.477-.168Z",
    transform: "translate(160.654 88.31)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M16.412,9.071a1.509,1.509,0,0,1-.838,1.862c-.894.3-1.639-.466-2.03-1.062.391-.615.466-1.434,1.36-1.583a1.862,1.862,0,0,1,1.509.819Z",
    transform: "translate(165.093 89.201)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M17.03,9.146c.372.968-.521,1.285-1.117,1.732a3.184,3.184,0,0,1-1.434-.615A1.732,1.732,0,0,1,15.521,8.4a1.862,1.862,0,0,1,1.509.838Z",
    transform: "translate(178.276 90.821)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M15.489,9.012c.372.168.223.689.149.913-.447.3-1.043,1.062-1.732.615a1.3,1.3,0,0,1-.745-1.453,1.415,1.415,0,0,1,2.328,0Z",
    transform: "translate(159.181 91.905)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M15.779,9.26a1.006,1.006,0,0,1-.6,1.211c-.521.521-1.117,0-1.639-.223a1.229,1.229,0,0,1,0-1.136,1.6,1.6,0,0,1,.968-.615c.521.149,1.117.149,1.341.764Z",
    transform: "translate(163.082 92.197)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M17.81,9.549c.149.764-.6,1.062-1.117,1.211-.913.3-1.36-.372-1.732-.987,0-.447.447-.745.6-1.136C16.618,8.189,17.288,8.953,17.81,9.549Z",
    transform: "translate(185.523 92.28)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M17.565,9.424c.279.764-.54,1.136-.838,1.509a1.527,1.527,0,0,1-1.658-.3C14.7,10.411,14.7,9.945,14.7,9.5c.447-.372.689-.819,1.211-.987a2.011,2.011,0,0,1,1.658.913Z",
    transform: "translate(181.726 92.406)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M21.5,12.945a11.175,11.175,0,0,1,1.658,3.017c-.149.242-.521.168-.67.168-2.552-1.453-5.867-3.036-6.835-6.053-.223-.3-.838-.689-.745-1.211,1.862-.372,3.725,1.062,5.177,2.123C20.61,11.735,21.206,12.107,21.5,12.945Z",
    transform: "translate(184.678 96.669)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M23.333,10.172c0,.913-1.658.689-2.328,1.36a16.054,16.054,0,0,1-7.878,1.136V12.22a11.174,11.174,0,0,1,10.206-2.049Z",
    transform: "translate(159.066 109.798)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M16.565,10.951a2.123,2.123,0,0,1-1.117,1.732c-.67.168-1.136-.223-1.658-.521s-.149-.838-.224-1.211a1.62,1.62,0,0,1,3,0Z",
    transform: "translate(164.549 113.097)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M24.844,10.5A12.2,12.2,0,0,1,18.4,13.14H14.34l-.372-.3c2.477-3.017,6.984-3.017,10.876-2.719v.447Z",
    transform: "translate(171.206 113.851)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M7.729,11.1c.223.391-.149.615-.3.987a1.266,1.266,0,0,1-1.434,0A.968.968,0,0,1,5.55,10.8c.223-.447.67-.372.894-.67a2.086,2.086,0,0,1,1.285.968Z",
    transform: "translate(48.381 115.814)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M11.049,17.343c-.745.894-1.862-.223-2.738-.67-2.589-1.49-2.514-4.4-5.1-6.09.3-.894.968,0,1.471,0a8.828,8.828,0,0,0,1.564.8c2.514,1.415,3.092,3.725,4.8,6.034Z",
    transform: "translate(15.951 116.558)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M25.747,10.514c0,.242.447.317.3.689A15.644,15.644,0,0,1,15.988,14.37c-.3,0-.6.317-.968.223s-.3-.372-.149-.521A11.491,11.491,0,0,1,25.747,10.514Z",
    transform: "translate(182.465 117.836)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M17.394,11.19c.3,1.062-.372,1.676-1.192,2.049a2.142,2.142,0,0,1-1.658-1.211c-.224-.6.3-.913.521-1.285a1.415,1.415,0,0,1,2.328.447Z",
    transform: "translate(178.731 118.371)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M7.957,10.938a1.583,1.583,0,0,1-.372,1.6,1.546,1.546,0,0,1-1.36.372c-.521,0-.819-.689-.968-1.136a1.639,1.639,0,0,1,.968-1.434A1.941,1.941,0,0,1,7.957,10.938Z",
    transform: "translate(45.508 118.828)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M13.039,15.381v.54a5.848,5.848,0,0,1-4.88-1.136A10.094,10.094,0,0,0,4.174,11.06c0-.223-.447-.54,0-.689,3.725,0,6.016,3.036,8.865,5.066Z",
    transform: "translate(27.017 119.246)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M7.968,11.224c0,.838-.54.987-1.062,1.434-.6,0-.894-.372-1.266-.819-.317-.764.372-1.062.745-1.453a1.6,1.6,0,0,1,1.583.838Z",
    transform: "translate(49.873 119.324)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M5.328,11.029a1.453,1.453,0,0,1,0,1.639,1.732,1.732,0,0,1-1.695.3,1.378,1.378,0,0,1-.6-1.862c.447-.67,1.769-1.043,2.291-.149Z",
    transform: "translate(11.243 120.041)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M5.963,11.075c.149.6.3,1.639-.577,1.862-1.043.447-1.639-.3-2.235-.894a1.7,1.7,0,0,1,.894-1.49,2.03,2.03,0,0,1,1.862.6Z",
    transform: "translate(15.115 121.335)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M6.524,11.172c0,.521,0,1.266-.521,1.415a3.223,3.223,0,0,1-1.4.149c-.149-.447-.968-.819-.521-1.341a2.943,2.943,0,0,1,1.024-.819C5.555,10.8,6.226,10.576,6.524,11.172Z",
    transform: "translate(26.679 122.206)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M7.959,11.789c.317.819-.6.968-.819,1.434-.3.149-.894.223-1.117,0a1.762,1.762,0,0,1-.6-1.6c.372-.3.521-.6.968-.745.819-.223,1.117.521,1.564.987Z",
    transform: "translate(47.238 125.948)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M17.541,11.874c.168.391-.279.838-.372,1.211a1.434,1.434,0,0,1-1.639.3c-.372-.521-.987-.968-.764-1.732a1.546,1.546,0,0,1,2.775.223Z",
    transform: "translate(182.03 126.682)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M6.42,12.2c-.223.67-.521,1.117-1.266,1.192A1.453,1.453,0,0,1,3.831,12.5c0-.521.3-.819.372-1.192C5,10.64,6.476,11.087,6.42,12.2Z",
    transform: "translate(24.938 128.252)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M11.483,11.129c0,1.043-1.136,1.658-1.509,2.719a7.617,7.617,0,0,1-6,4.973c-.3-.67.968-1.509,1.266-2.179,1.211-2.57,3.613-3.93,5.792-5.587Z",
    transform: "translate(26.394 129.103)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M17.751,12.193a2.105,2.105,0,0,1-1.285,1.751c-.615.317-1.192-.317-1.564-.615-.6-.6-.224-1.211,0-1.862.894-.913,2.179-.149,2.775.67Z",
    transform: "translate(180.032 129.082)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M17.979,12.035a1.862,1.862,0,0,1-1.36,1.658c-.149-.224-.521,0-.745-.149a1.7,1.7,0,0,1-.987-1.36c.391-.372.54-.987,1.062-1.062S17.812,11.123,17.979,12.035Z",
    transform: "translate(184.478 129.78)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M7.58,12.01a1.639,1.639,0,0,1-1.117,1.583,1.471,1.471,0,0,1-1.434-.913c-.149-.67.54-1.136.913-1.509.894-.3,1.117.372,1.639.838Z",
    transform: "translate(41.918 129.731)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M8.143,12.251a1.862,1.862,0,0,1-1.415,1.285c-.521-.149-1.136-.3-1.36-.913s.54-1.136,1.062-1.509a1.564,1.564,0,0,1,1.713,1.136Z",
    transform: "translate(46.533 129.787)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M8.276,11.862c0,.615.223,1.527-.521,1.862a1.471,1.471,0,0,1-1.862-.913c-.372-.894.447-1.062.913-1.509.6-.149.968.149,1.415.521Z",
    transform: "translate(53.309 132.132)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M18.97,14.85a11.174,11.174,0,0,1,1.862,5.364c-.224.54.372,1.062,0,1.434h-.3c-3.371-2.4-4.116-5.811-5.4-9.312a.615.615,0,0,1-.3-.745c.745-.689,1.266.67,2.03.913l2.1,2.254Z",
    transform: "translate(183.245 134.061)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M16.569,12.013v.149c-3,2.123-7.208,3.408-10.653,1.36a.559.559,0,0,1,.372-.67,15.421,15.421,0,0,1,6.593-1.434l3.613.6Z",
    transform: "translate(54.775 134.328)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M14.608,12.107c-2.626,1.658-4.879,4.675-8.027,5.382-.6.223-.968,1.062-1.732.6,1.36-4.079,5.792-6.276,9.759-6.649v.615Z",
    transform: "translate(39.621 134.625)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M17.311,12.4c.224.615,0,1.434-.6,1.583a1.024,1.024,0,0,1-1.434,0c-.67-.3-.67-.968-.67-1.509s.745-.6,1.117-.819C16.4,11.8,16.938,11.8,17.311,12.4Z",
    transform: "translate(180.472 137.725)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M23.56,12.057a4.172,4.172,0,0,1-2.7,1.974c-2.551.913-4.861-.3-7.114-.913,0-.6.819-.372,1.192-.745a16.315,16.315,0,0,1,7.654-.391.782.782,0,0,1,.968,0Z",
    transform: "translate(167.984 138.437)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M8.13,13.068c-.223.3-.3.987-.894,1.211a1.6,1.6,0,0,1-1.509-.3c-.149-.466-.67-.838-.3-1.36a2.07,2.07,0,0,1,1.211-.838A1.6,1.6,0,0,1,8.13,13.068Z",
    transform: "translate(46.099 139.624)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M8.429,13.113c-.223.447-.447,1.136-1.043,1.434a1.62,1.62,0,0,1-1.509-.54A1.862,1.862,0,0,1,5.654,12.5c.149-.372.67-.447,1.043-.67A2.183,2.183,0,0,1,8.429,13.113Z",
    transform: "translate(50.232 140.268)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M17.617,13.047a1.974,1.974,0,0,1-.521,1.434,1.248,1.248,0,0,1-1.639.317c-.54,0-.689-.689-.913-1.062s.3-.987.521-1.509a1.62,1.62,0,0,1,2.551.819Z",
    transform: "translate(178.731 141.079)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M17.258,12.559c0,.372.3.764.149,1.062-.466.372-.764,1.36-1.658.987-.447.149-.67-.466-.894-.615a1.487,1.487,0,0,1,.894-2.03C16.42,11.721,16.886,12.336,17.258,12.559Z",
    transform: "translate(182.405 141.418)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M8.381,13.05a1.993,1.993,0,0,1-.764,2.03c-.819.168-1.862.168-2.16-.819a2.03,2.03,0,0,1,.894-2.2A1.862,1.862,0,0,1,8.381,13.05Z",
    transform: "translate(47.579 143.125)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M11.757,12.071c-.149,2.1-.6,4.675-2.682,5.885-1.211.223-2.421,1.36-3.613.615v-.391C7.045,15.926,9.894,14.175,11.757,12.071Z",
    transform: "translate(48.469 143.769)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M16.561,13.254c.3.447-.223.838-.447,1.211s-1.285.3-1.862,0a1.124,1.124,0,0,1-.372-1.509,1.49,1.49,0,0,1,.968-.838,2.265,2.265,0,0,1,1.658,1.062Z",
    transform: "translate(168.017 144.448)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M9.857,16.351c1.062,1.732.466,4.079,1.062,5.96-1.285.149-1.862-1.285-2.626-2.03-1.658-2.272-1.434-5.289-2.179-7.934a.391.391,0,0,1,.521-.168,18.624,18.624,0,0,1,2.849,3.185C9.336,15.886,9.932,15.886,9.857,16.351Z",
    transform: "translate(57.874 144.74)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M16.534,13.154c0,.615-.67.764-1.043,1.136a2.831,2.831,0,0,1-1.434-.67c-.223-.764.372-.987.764-1.36a1.248,1.248,0,0,1,1.713.894Z",
    transform: "translate(171.787 145.05)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M19.271,18.9c0,.224,0,.67-.466.521h-.3c-2.16-1.974-4.339-4.153-4.041-7.189h.447c2.03,1.751,4.284,3.725,4.358,6.742Z",
    transform: "translate(177.99 146.05)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M17.12,13.545a1.713,1.713,0,0,1-.67,1.434c-.819.223-2.1.149-2.254-.987,0-.764.764-1.136,1.136-1.509a1.527,1.527,0,0,1,1.862,1.062Z",
    transform: "translate(174.498 148.98)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M19.76,14.087c-1.043,2.794-3.892,4.228-5.848,6.351-.372-.223-.224-.838-.149-1.136a10.485,10.485,0,0,1,5.773-6.8C20.747,12.653,19.536,13.472,19.76,14.087Z",
    transform: "translate(166.904 150.021)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M16.956,13.57c0,.67-.689.968-1.062,1.36a2.16,2.16,0,0,1-1.639-.838c0-.764.521-.987.968-1.36a1.564,1.564,0,0,1,1.732.838Z",
    transform: "translate(175.351 152.81)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M18.042,11.95c-.8.3-1.117.521-.913,1.341l.931,3.986a3.464,3.464,0,0,1-.261,2.607,4.861,4.861,0,0,1-2.719,1.62,5.587,5.587,0,0,1-3.2,0,2.347,2.347,0,0,1-1.564-2.011l-.987-4.3c-.242-1.043-.633-.968-1.49-.857v-.3l5.028-1.211v.317c-.968.261-1.434.391-1.173,1.49l.987,4.172c.168.708.577,2.44,2.719,1.862a2.421,2.421,0,0,0,2.011-3.352l-.894-3.725c-.186-.764-.466-1.155-1.751-.894v-.317l3.278-.782v.317Z",
    transform: "translate(82.728 136.924)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M14.736,14.251a3.222,3.222,0,0,0-3.445-1.676c-.764.186-1.509.745-1.322,1.546s.484.894,1.862,1.136l2.384.428a2.7,2.7,0,0,1,2.16,1.862c.242,1.117-.391,2.831-3.129,3.445a12.832,12.832,0,0,1-2.645.149.447.447,0,0,0-.354.521l-.447.112-.67-3.11.428-.093a3.166,3.166,0,0,0,3.725,1.993c1.862-.391,1.6-1.658,1.564-1.862-.186-.838-.95-.987-2.011-1.155l-1.08-.186c-2.794-.466-3.036-1.527-3.147-2.1s0-2.57,2.756-3.222a13.388,13.388,0,0,1,2.421,0c.335,0,.372-.279.391-.54h.447l.6,2.719h-.41Z",
    transform: "translate(93.484 135.461)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M17.2,20.266l-5.457.54v-.335c1.1-.168,1.471-.242,1.36-1.3l-.633-6.742c-1.062.149-2.626.354-2.738,2.44H9.284L9.1,12.3l9.144-.875.242,2.589h-.428c-.5-2.011-2.086-1.862-3.147-1.862l.652,6.742c0,1.08.466,1.08,1.6,1.024v.317Z",
    transform: "translate(100.929 134.381)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M20.235,20.144H17.088l-3.073-4.079h-.391V18.6c0,1.024.317,1.062,1.322,1.211v.317l-5.177-.112V19.7c1.043,0,1.36-.112,1.378-1.155l.112-5.587c0-1.1-.466-1.136-1.322-1.211v-.317h4.935c1.062,0,4.3.186,4.265,2.347,0,1.583-1.62,1.862-2.44,2.16l3,3.725a.726.726,0,0,0,.615.261v.317Zm-6.612-4.563c2.011,0,2.812-.242,2.831-1.862a1.62,1.62,0,0,0-1.862-1.862c-.838,0-.875.13-.968.54v3.259Z",
    transform: "translate(110.612 134.503)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M20.747,20.891l-4.917-.615v-.335c.95,0,1.229,0,1.285-.335a6.686,6.686,0,0,0-.5-1.862L13.2,17.315a8.473,8.473,0,0,0-.875,1.564c0,.484.67.615,1.173.708V19.9l-3.073-.391V19.2c.819,0,1.1-.41,1.676-1.3l4.265-6.425H16.8l2.552,7.114c.521,1.453.708,1.862,1.434,1.993v.317ZM16.5,17.3,15.271,14l-1.862,2.924,2.98.372Z",
    transform: "translate(120.139 135.06)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M19.827,21.666l-8.716-1.6v-.317c.857,0,1.322.112,1.471-.652l1.1-6.127c.149-.819-.466-.968-1.136-1.136v-.3l5.271.95V12.8c-1.062-.149-1.527-.223-1.732.894L15,19.655c0,.615.2.764,1.211.95a3.725,3.725,0,0,0,4.265-1.769h.447Z",
    transform: "translate(129.98 136.036)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M16.962,21.266,11.71,20.149v-.317c.819.112,1.415.186,1.564-.6l1.266-6.071c.168-.838-.54-1.006-1.211-1.192v-.317l5.252,1.1v.317c-.708-.112-1.415-.261-1.6.6l-1.248,6.09c-.168.8.41.968,1.229,1.192Z",
    transform: "translate(138.619 137.795)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M22.423,21.233l-4.935-.521v-.317c.95,0,1.229,0,1.266-.372a6.665,6.665,0,0,0-.521-1.862l-3.427-.354a7.226,7.226,0,0,0-.838,1.583c0,.484.67.6,1.192.67v.317l-3.092-.317v-.317c.819,0,1.08-.428,1.639-1.341l4.1-6.649h.428l2.7,7.077c.559,1.434.745,1.862,1.49,1.956v.447Zm-4.339-3.5-1.229-3.259-1.732,2.943Z",
    transform: "translate(143.792 139.188)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M13.249,10.43a1.248,1.248,0,1,0-1.4-1.248,1.341,1.341,0,0,0,1.4,1.248Z",
    transform: "translate(140.674 84.211)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M12.121,5.142a7.955,7.955,0,0,0-.652,1.322.67.67,0,0,0,1.341,0Z",
    transform: "translate(135.153 43.795)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M11.414,5.142a7.861,7.861,0,0,0-.67,1.322.689.689,0,1,0,1.36,0Z",
    transform: "translate(124.537 43.795)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M12.159,6.156a7.953,7.953,0,0,0-.652,1.322.67.67,0,1,0,1.341,0Z",
    transform: "translate(135.693 58.426)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M12.159,7.13a7.953,7.953,0,0,0-.652,1.322.67.67,0,0,0,1.341,0Z",
    transform: "translate(135.693 72.481)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M12.068,7.9a7.86,7.86,0,0,0-.67,1.322.689.689,0,1,0,1.36,0Z",
    transform: "translate(133.977 83.663)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M11.425,8.318a7.954,7.954,0,0,0-.652,1.322.67.67,0,1,0,1.341,0Z",
    transform: "translate(125.103 89.619)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M4.414,13.348a1.322,1.322,0,1,0-1.4-1.322,1.36,1.36,0,0,0,1.36,1.322Z",
    transform: "translate(13.199 124.072)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M6.382,11.737H6.289v-.112H6.14v-.037h.242V11.7Zm-.223-.149Z",
    transform: "translate(58.257 136.802)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M6.271,11.588h0a.112.112,0,0,1-.112,0h.093Z",
    transform: "translate(58.536 136.802)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M6.285,11.588v.223h0v-.186h0l-.093.186h0v-.223h.093v.13h0v-.112h.093v.13h0v-.13h0Z",
    transform: "translate(59.006 136.802)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M6.2,11.6a.112.112,0,0,0,.13,0H6.44c.112,0,.093,0,.093.112s0,.13-.2.149Zm.112,0Z",
    transform: "translate(59.093 136.941)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M6.337,11.71h0a.13.13,0,0,1-.13,0h.019v-.13h.13Z",
    transform: "translate(59.215 136.68)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M17.633,20.039l-4.917.577V20.3c.931-.186,1.211-.223,1.155-.652a6.779,6.779,0,0,0-.894-1.62l-3.427.41a6.556,6.556,0,0,0-.466,1.713c0,.484.782.447,1.3.41v.317L7.3,21.231v-.317c.819-.186.968-.652,1.322-1.658l2.57-7.45h.428l4.153,6.314c.857,1.285,1.136,1.695,1.862,1.583v.317ZM12.66,17.562,10.8,14.638,9.736,17.916l2.961-.354Z",
    transform: "translate(74.942 139.972)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M121.838,15.753a7.915,7.915,0,0,0-5.1-4.675,6.593,6.593,0,0,0-6.537,1.658c-2.7,2.2-.82,5.829-.745,8.772,0,.6,0,1.062-.521,1.36-10.9-.987-21.027-3.725-31.828-4.842-2.477-.428-4.973-.317-7.338-.819l-3.017-.317A126.459,126.459,0,0,0,39.222,20c-1.862.6-3.986.745-5.867,1.434-1.341-.223-2.477.745-3.725.372l-2.477.577a1.863,1.863,0,0,1-.819,0c-1.211-3.092,2.4-4.973,1.266-8.008a5.587,5.587,0,0,0-5.177-3.092,6.276,6.276,0,0,0-6,3.092c-1.732,3.725.447,7.71,1.117,11.417-.149,1.211,1.211,2.57,0,3.557A10.262,10.262,0,0,0,9.07,27.6c-.913.466-2.551-.149-3,.913,3.222,1.732,7.45,1.509,10.951,1.36a1.185,1.185,0,0,1,1.117,0c.317,1.974-.372,4.619.838,6.351a7.654,7.654,0,0,0,5.773,2.5c6.91-.223,13.037-2.272,19.35-3.855.987,0,1.732-.6,2.794-.6a54.006,54.006,0,0,1,10.653-1.434,18.81,18.81,0,0,0-3.166,6.8c-.894,2.03,1.583,2.347,2.328,3.464-2.328.689-3.967,2.272-6.146,3.185-4.8-.149-8.865,1.658-13.353,2.179,0,.987,1.564.689,1.713,1.676-.223.67-.894.745-1.415,1.136,0,.447,0,.521.447.6.447-.521,1.434-.149,1.862-.67,1.49,0,2.775-.466,4.19-.54a13.614,13.614,0,0,0,3.837-1.509c1.564-.447,2.551-1.509,4.135-1.974,2.235,0,4.265-.745,6.369-.894v.447c-1.732,2.794-3.52,5.68-5.326,8.325a.838.838,0,0,0,.521,1.192,3.837,3.837,0,0,0,2.924-.447c1.583-2.719,3-5.289,4.284-8.083.521-2.57,2.4-3.93,4.284-5.587.3-.168.745-.615,1.043-.168a34.435,34.435,0,0,0-3.594,5.289A6.388,6.388,0,0,0,63.6,53.839c.894.745,2.254.521,3.445.6,2.924-1.509,6.686.913,8.94-1.862,1.341-.242,1.564,1.36,2.328,2.1,1.266.372,2.626,1.658,3.892.764,0-.838-.968-1.6-1.415-2.347-.913-1.583-2.03-2.868-2.849-4.3a14.08,14.08,0,0,1-1.211-2.812,24.211,24.211,0,0,0,4.06,1.6,23.463,23.463,0,0,1,4.041,1.211,14.006,14.006,0,0,0,3.725,2.868c1.862.913,3.967,1.062,5.922,1.862.745,0,1.862.689,2.4,0a3.11,3.11,0,0,0-1.117-.819c-.242-.987,1.341-.466,1.862-1.211a1.062,1.062,0,0,0-.857-.689c-1.08-.577-3.725-.782-4.47-1.173a17.768,17.768,0,0,1-2.626-.819c-4.507,0-6.984-4.079-10.578-5.587.819-.745,2.1-1.36,2.626-2.5a4.228,4.228,0,0,0,.224-4c-.67-2.328-3.725-2.03-5.4-3.315l.223-.224a31.754,31.754,0,0,1,8.1,1.043c7.207.987,13.894,3.725,21.4,3.855,4.116,0,9.312.242,11.323-3.725.372-2.347.819-4.693,1.192-7.04.913-3.725,3.39-7.245,3.017-11.417ZM40.787,50.226l-1.043-.987c.521-.67,1.639-.3,2.477-.764a13.037,13.037,0,0,1,6.369-.894C46.337,49.444,43.413,49.612,40.787,50.226Zm46.858-1.285a32.479,32.479,0,0,0,7.99,1.862c-.223,1.024-2.067,0-1.862,1.509-2.328-.913-5.028-1.36-6.761-3.185.149,0,.3-.3.615-.223ZM17.227,16.889a5.438,5.438,0,0,1,1.862-3.725,6.351,6.351,0,0,1,5.922.242,2.942,2.942,0,0,1,1.211,1.434,3.352,3.352,0,0,1-1.136,3.39h-.745a8.288,8.288,0,0,1,.447-3.39c0-.913-.819-.987-1.434-1.36a4.339,4.339,0,0,0-3.371.745,3.445,3.445,0,0,0-.968,3.334c.521.819,0,1.862.372,2.868l-.223.3c-.913-.987-2.1-2.03-1.862-3.725Zm3.52,2.253c1.136.838,2.7.466,4.06.689a2.868,2.868,0,0,1-.372,2.57c-1.285-.317-2.924-.149-3.613-1.36.149-.54-.223-1.285,0-1.862Zm-.223-2.533c.223-.615,0-1.509.838-1.658.521-.149,1.341-.149,1.415.447a15.085,15.085,0,0,1-.372,2.645,1.732,1.732,0,0,1-1.862-1.434Zm35.2,24.211a8.213,8.213,0,0,1,2.4-6.779,4.377,4.377,0,0,1,3.259,0c-1.862.54-4.432.987-4.879,3.483,0,.987-.224,1.509.223,2.347.838,1.434,2.7.838,3.725,1.862a.968.968,0,0,1-.67.913A28.473,28.473,0,0,1,55.8,40.784Zm-2.7,5.215c1.862-.764,3.725-2.347,5.7-1.676a10.411,10.411,0,0,1-5.7,1.676Zm7.133.745A58.7,58.7,0,0,1,56.431,53.9c-.149.372-.745.447-1.192.521,0-1.062,1.043-1.862,1.49-2.794,1.583-2.049,2.03-4.228,3.837-6.2.447.447-.447.764-.447,1.36ZM62.018,42.4v.3h-.149V42.33h.3a.447.447,0,0,0-.3,0Zm-.67-2.049a18.122,18.122,0,0,1-3.594-.894c-.764-.764,0-1.6,0-2.421,1.043-1.676,4.041-2.5,5.475-.987a7.934,7.934,0,0,1-1.862,4.3Zm1.658,0A12.832,12.832,0,0,1,64.2,37.19,6.3,6.3,0,0,1,63.005,40.356Zm.819-6.109c-.968-.242-1.509-1.36-2.552-1.36a5.848,5.848,0,0,1,2.849,0c.372.54-.223.987-.3,1.453Zm.894,2.254h0v-.819h0Zm0,3.483a6.8,6.8,0,0,1,.223-1.062c.372-.372.745.3.894.54a1.118,1.118,0,0,1-1.117.521Zm1.117-4.693A8.623,8.623,0,0,1,66.953,32.5a4.451,4.451,0,0,1,2.03.3c.149,1.527,2.03,3.557,0,4.842-.67.3-1.658.987-2.4.3a2.1,2.1,0,0,1-.745-2.645Zm5.475-2.1c-.149-.689.67-.149.968-.466l2.328.168C73.416,32.72,71.907,35.532,71.311,33.185Zm3.725.968c-.913.317-1.583,1.378-2.477,1.6a3.036,3.036,0,0,1,2.607-1.713ZM71.87,38.847v.223h0Zm.149,4.619a.709.709,0,0,1-.149.521l-1.713-1.36A1.862,1.862,0,0,1,72.019,43.466Zm-2.011-2.347a.559.559,0,0,1,.67,0Zm-1.062-1.136c.3-.447.67-1.136,1.211-1.136a.265.265,0,0,0,.149.223A3.892,3.892,0,0,1,68.946,39.983Zm-1.713-.149h-.261l.466-.447c.223.149-.093.3-.149.447Zm.223,2.868c.968-1.062,1.862.6,2.235,1.434,1.136,1.658,4.06,3.185,2.943,5.438-1.434,1.285-3.725,0-5.252,1.062-.838,0-2.254.149-2.7-.67A42.838,42.838,0,0,1,67.456,42.7Zm-2.1,1.434.372-.6a32.925,32.925,0,0,1-2.347,5.4c-.447-1.862,1.434-3.259,2.1-4.842Zm3.483,8.958c-1.415,0-3.594.913-4.954-.3,0-.615-.6-.913-.521-1.509,1.192-.466,2.253.968,3.371,0a29.094,29.094,0,0,1,5.252.149c.838.224,2.1-1.36,2.253.224-.6,2.5-3.594.745-5.4,1.509Zm4.358-10.876v-.223h.149v.223Zm.447,4.749c0,.764.819,1.062.372,1.751a2.365,2.365,0,0,1-.372-1.751Zm2.1,4.544-.372.149c-.391-.3-.242-1.136-.149-1.583C75.669,50.45,76.042,50.971,75.744,51.511Zm3.725,1.862c0,.224-.447.224-.6,0a40.115,40.115,0,0,1-4.731-9.07h.3C76.3,47.247,77.662,50.506,79.469,53.374Zm2.775-6.947a.3.3,0,0,0-.149.3,8.623,8.623,0,0,1-5.252-2.347v-.372a13.987,13.987,0,0,1,5.475,2.421ZM80.288,36.37c.913.223.987,1.211,1.062,1.974a4.451,4.451,0,0,1-5.475,4,4.842,4.842,0,0,0,4.507-2.57Zm-1.639-.3a5.122,5.122,0,0,1,.67,3.334c-.745,1.434-2.253,1.434-3.594,1.732a2.309,2.309,0,0,1-1.732-.54.764.764,0,0,0-.3-.745c.223-.987-1.732-1.974-.372-2.794C74.515,35.923,77.364,33.334,78.649,36.072Zm38.123-5.587c-.615.745,0,1.956-.838,2.645,0,1.36-1.117,2.03-2.1,2.57-8.921,1.862-17.693-1.062-26.334-2.57A91.816,91.816,0,0,0,49,32.515c-5.773,1.062-11.4,2.421-16.948,4a24.342,24.342,0,0,1-10.5,0c-2.7-1.285-1.583-4.749-2.4-7.17a39.519,39.519,0,0,0-.6-5.215,4.321,4.321,0,0,1-.317-1.974c1.136.149,2.253.987,3.464,1.285,6.295,1.211,11.919-.819,17.786-1.862A128.08,128.08,0,0,1,56.8,18.938c6.76,0,13.67-.466,20.114.67,2.1,0,3.911.615,5.922.764,4.209.521,8.12,1.658,12.385,1.862a17.223,17.223,0,0,0,2.254.391c6.76,1.062,14.34,2.943,20.784,0a56.229,56.229,0,0,1-1.49,7.859Zm-2.1-9.219c0,1.211-1.062.894-1.658,1.36h-1.862a4.171,4.171,0,0,1-.223-2.123,14.6,14.6,0,0,1,3.725.764ZM113.83,19.4c.838-.819-.223-5.587,2.1-2.5a2.665,2.665,0,0,1-.521,1.974C114.892,19.348,114.445,19.776,113.83,19.4Zm6.09-.745a4.358,4.358,0,0,1-3.222,2.57c0-1.862,1.713-3.11,1.117-5.14a4.507,4.507,0,0,0-4.731-1.527c-.67.466-.372,1.211-.6,1.862l-.3,2.5c-1.509,0-1.583-1.36-2.03-2.421a4.377,4.377,0,0,1,2.328-3.93,5.177,5.177,0,0,1,4.358.149,3.408,3.408,0,0,1,2.477,1.583c1.117,1.062.819,2.961.6,4.321Z",
    transform: "translate(57.264 125.522)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M17.569,6.766a8.828,8.828,0,0,1,1.043,9.312c-.819,0-.671-1.117-.819-1.732-1.509-2.794-2.7-6.351-1.341-9.517.968.149.6,1.36,1.117,1.862Z",
    transform: "translate(198.447 39.284)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M19.1,5.939c.447.838-.391,1.658-.987,2.049a1.974,1.974,0,0,1-1.862-.838,1.751,1.751,0,0,1,.913-1.974,1.955,1.955,0,0,1,1.955.764Z",
    transform: "translate(203.381 43.744)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M19.257,6.2a1.639,1.639,0,0,1,0,1.192,1.713,1.713,0,0,1-2.03.689A2.142,2.142,0,0,1,16.389,6.8a2.365,2.365,0,0,1,1.285-1.36,2.421,2.421,0,0,1,1.583.764Z",
    transform: "translate(206.144 48.097)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M18.692,5.878c.6.3.149,1.043,0,1.509-.372.372-.894.968-1.583.745-.372-.372-.819-.372-.968-.894a1.676,1.676,0,0,1,1.043-1.751,1.862,1.862,0,0,1,1.434.391Z",
    transform: "translate(202.389 48.497)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M18.4,6.386c0,.838,0,1.862-.913,2.049a1.415,1.415,0,0,1-1.713-1.062A1.863,1.863,0,0,1,16.9,5.51,2.067,2.067,0,0,1,18.4,6.33Z",
    transform: "translate(197.238 49.107)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M18.478,8.58a10.783,10.783,0,0,1,.372,7.263l-.447.372a29.352,29.352,0,0,1-3.073-6.109,9.871,9.871,0,0,1,.913-4.321c.521-.372.819,0,1.043.54A2.961,2.961,0,0,0,18.478,8.58Z",
    transform: "translate(190.851 50.918)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M18.864,6.726a1.862,1.862,0,0,1-1.117,1.862,1.341,1.341,0,0,1-1.732-.913,1.62,1.62,0,0,1,.819-1.862c.838-.466,1.658.3,2.03.894Z",
    transform: "translate(199.926 51.411)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M23.87,5.852c0,.987-1.583,1.956-1.732,2.943a7.45,7.45,0,0,1-4.656,4.228,3.446,3.446,0,0,1-1.713.987c-.149-1.509,1.192-2.868,2.03-4.228a10.97,10.97,0,0,1,6.071-3.93Z",
    transform: "translate(197.025 54.037)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M23.091,6.126a9.647,9.647,0,0,1-4.656,8.157c-.819.317-1.713,1.136-2.551.615A37.827,37.827,0,0,1,22.5,6.126Z",
    transform: "translate(198.847 57.99)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M18.317,7.132a1.862,1.862,0,0,1-1.36,2.179,2.146,2.146,0,0,1-1.732-1.192,1.6,1.6,0,0,1,1.062-1.676,1.248,1.248,0,0,1,.894-.224c.447.149.67.521,1.062.913Z",
    transform: "translate(189.224 59.182)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M17.991,7.277c.3.838-.372,1.434-.968,1.732-.764-.223-1.732-.372-1.732-1.36a1.453,1.453,0,0,1,1.117-1.136A1.471,1.471,0,0,1,17.991,7.277Z",
    transform: "translate(190.295 63.19)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M18.065,7.149c.223.372.745.987.149,1.36a2.718,2.718,0,0,0-.764.6,1.453,1.453,0,0,1-1.862-.894c-.168-.838.521-1.211,1.117-1.6s.894.242,1.285.54Z",
    transform: "translate(194.207 63.169)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M19.259,7.739a1.993,1.993,0,0,1-.987,1.434A1.471,1.471,0,0,1,16.6,8.745c-.447-.149-.3-.764-.3-1.136a2.514,2.514,0,0,1,1.415-.987,2.645,2.645,0,0,1,1.508,1.062Z",
    transform: "translate(204.485 65.149)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M19.181,7.616a1.862,1.862,0,0,1-1.434,1.36c-.447,0-1.266-.223-1.117-.894a1.3,1.3,0,0,1,2.551-.466Z",
    transform: "translate(209.35 65.942)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M18.568,7.432a2.68,2.68,0,0,1-1.043,1.751,1.3,1.3,0,0,1-1.509-.913,1.527,1.527,0,0,1,.838-1.434,1.639,1.639,0,0,1,1.713.6Z",
    transform: "translate(200.744 67.486)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M19.52,7.792c-.168.689,0,1.453-.838,1.862a2.123,2.123,0,0,1-1.862-.3,1.4,1.4,0,0,1-.317-1.6,1.862,1.862,0,0,1,1.862-.894c.521.3.67.67,1.136.894Z",
    transform: "translate(205.956 68.336)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M24.773,9.365c.3,0,.149.521,0,.67a5.7,5.7,0,0,1-6.09-.3,20.486,20.486,0,0,0-3-1.658c.372-.987,1.732-.913,2.7-1.136,2.179.3,3.911,2.347,6.314,2.421Z",
    transform: "translate(195.973 69.799)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M25.914,7.951c-2.4,3.39-4.954,7.245-9.144,8.455-.317,0-.615.149-.764-.224,2.551-2.719,3.911-6.965,7.878-7.934a2.421,2.421,0,0,1,2.03-.3Z",
    transform: "translate(200.606 82.853)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M19.453,8.878c.223.764-.447,1.136-.968,1.583a1.676,1.676,0,0,1-1.434-.223c0-.372-.521-.67-.372-1.211a1.62,1.62,0,0,1,1.732-.913,12.374,12.374,0,0,1,1.043.764Z",
    transform: "translate(209.916 86.377)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M19.753,8.625c.447.67,0,1.211-.3,1.732a1.006,1.006,0,0,1-1.36.447c-.447-.447-1.043-.67-1.117-1.36S17.649,8.4,18.1,8.159c.764-.3,1.062.466,1.658.466Z",
    transform: "translate(214.569 86.333)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M19.339,9.772a2.254,2.254,0,0,1-1.266,1.211c-.6.149-.968-.372-1.434-.615s-.223-.968,0-1.36a1.49,1.49,0,0,1,2.756.764Z",
    transform: "translate(205.896 89.412)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M19.684,9.542a1.862,1.862,0,0,1-1.862,1.285c-.67-.3-1.434-.819-.894-1.732.3-.3.447-.615.894-.689a1.453,1.453,0,0,1,1.862,1.136Z",
    transform: "translate(211.268 89.941)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M28.24,10.164c.149,1.062-1.211.521-1.732.819-3.147,1.862-7.207.466-10.206-.67.224-.987,1.341-.615,1.956-.987,3.222-2.049,6.518.447,9.74.615l.242.224Z",
    transform: "translate(204.89 92.578)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M18.211,9.447a1.862,1.862,0,0,1-.745,1.453,1.49,1.49,0,0,1-1.956-.838c-.223-.615.372-1.211.968-1.434a1.34,1.34,0,0,1,1.732.819Z",
    transform: "translate(192.775 92.904)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M18.552,9.893a1.6,1.6,0,0,1-1.192,1.36,1.713,1.713,0,0,1-1.434-.745,1.192,1.192,0,0,1,.3-1.434c.149-.242.67-.242.987-.391a1.639,1.639,0,0,1,1.341,1.211Z",
    transform: "translate(197.687 94.879)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M18.238,9.748c.149.913-.615,1.062-1.136,1.434a1.676,1.676,0,0,1-1.49-.913c-.242-.819.521-1.117.968-1.509a1.546,1.546,0,0,1,1.658.987Z",
    transform: "translate(194.258 95.806)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M21.641,11.836c.745,0,.894-.987,1.732-1.136a1.862,1.862,0,0,1,1.862.838c.3.894-.372,1.36-.968,1.732s-1.658-.466-1.583.521A2.328,2.328,0,0,1,23.746,15.3c-.149.317-.689.242-.913,0a9.442,9.442,0,0,1-5.4-4.675c-.3-.689-1.713-1.211-.894-1.862a6.965,6.965,0,0,1,5.177,2.961Z",
    transform: "translate(204.655 96.046)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M19.727,9.324a1.155,1.155,0,0,1,0,1.434c-.391.764-1.509.447-2.179.372-.372-.372-.745-.745-.6-1.36A2.365,2.365,0,0,1,18.069,8.8a2.067,2.067,0,0,1,1.732.521Z",
    transform: "translate(213.776 96.23)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M18.51,9.958c0,.466-.521.764-.745,1.062-.615,0-1.211.3-1.732-.224-.149-.372-.521-.987,0-1.36.819-1.062,2.03-.224,2.551.521Z",
    transform: "translate(197.133 98.52)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M20.025,9.862a1.751,1.751,0,0,1-1.043,1.862,1.862,1.862,0,0,1-1.862-.67c-.372-.447,0-.913,0-1.434a1.862,1.862,0,0,1,1.862-.54,4.655,4.655,0,0,1,.894.764Z",
    transform: "translate(214.297 99.678)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M23.428,10.494c-1.713,2.57-3.222,5.755-6.295,6.891-.521,0-.968.745-1.434.223a13.931,13.931,0,0,1,6.686-7.189,2.477,2.477,0,0,1,1.043,0Z",
    transform: "translate(196.182 119.141)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M22.713,10.878c-.67.987-.372,2.421-1.043,3.483-1.509,1.732-2.794,3.725-5.177,4.079-.372-.745.521-1.509.894-2.2a10.82,10.82,0,0,1,4.954-5.811Z",
    transform: "translate(206.357 120.117)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M20.038,11.8c-.223.54-.521,1.211-1.136,1.211a1.806,1.806,0,0,1-1.713-.838c-.372-.689.372-1.285.968-1.509A1.61,1.61,0,0,1,20.02,11.8Z",
    transform: "translate(216.24 122.751)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M19.4,11.9c.093.615-.6,1.062-.894,1.285a1.862,1.862,0,0,1-2.328-1.117A1.639,1.639,0,0,1,19.4,11.9Z",
    transform: "translate(203.131 123.026)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M19.661,11.491a1.546,1.546,0,0,1-.67,1.285,1.751,1.751,0,0,1-1.862-.3c-.67-.6-.149-1.136.3-1.583a1.525,1.525,0,0,1,2.179.6Z",
    transform: "translate(212.185 123.285)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M18.859,11.608a1.676,1.676,0,0,1-1.043,1.974c-.615.149-.987-.168-1.434-.54a.957.957,0,0,1,0-1.583,1.471,1.471,0,0,1,2.551.149Z",
    transform: "translate(199.931 125.291)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M19.787,11.929c.149.521-.3.764-.372,1.136a2.049,2.049,0,0,1-1.732.3c-.67-.372-.67-.987-.67-1.658.447-.3.521-.689,1.062-.838a1.7,1.7,0,0,1,1.713,1.062Z",
    transform: "translate(215.132 126.329)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M23.249,11.963c.3.913-.54,1.36-1.136,1.583-.3,0-.745-.149-.819.317a19.182,19.182,0,0,1,4.637,4v.6a10.075,10.075,0,0,1-7.45-2.868c-.54-.372-1.434-.372-2.03-.913.968-.968,2.775-.6,4.116-.67.987-1.062-1.117-1.862.168-2.719.447,0,.745-.54,1.341-.391a2.831,2.831,0,0,1,1.136,1.062Z",
    transform: "translate(207.033 126.519)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M22.019,17.279c.372.3,1.043.689.894,1.211-1.192.521-2.179-.838-3.3-1.062a15.291,15.291,0,0,1-3.892-6.053c.67-.67,1.415.168,2.011.391a14.583,14.583,0,0,1,4.283,5.587Z",
    transform: "translate(196.548 130.049)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M19.116,11.8a1.862,1.862,0,0,1-.149,1.658c-.447.764-1.434.615-2.1.466-.372-.466-1.043-1.062-.6-1.751a2.486,2.486,0,0,1,1.415-.987c.521-.242.913.391,1.434.615Z",
    transform: "translate(202.226 130.237)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiCoatOfArms);
export default __webpack_public_path__ + "static/media/DI_CoatOfArms.6842ddb675da4040ade424c60eb34adb.svg";
export { ForwardRef as ReactComponent };